/**
 * Supabase Public Configuration
 * ==============================
 * Single source of truth for public Supabase credentials.
 *
 * These are *public* (anon-key) values safe to ship in client bundles.
 * The hardcoded defaults keep signup/reset-password/login working even when
 * the build environment does not inject NEXT_PUBLIC_* vars (e.g. Vercel
 * preview deploys that inherit only production env). If the env vars *are*
 * present they take precedence.
 *
 * IMPORTANT: This is the ONLY file that should reference these env vars
 * directly. All other code should import from here.
 */

const FALLBACK_SUPABASE_URL = 'https://ctecsrvnuxcmlzgmavoj.supabase.co'
const FALLBACK_SUPABASE_ANON_KEY =
  'sb_publishable_9Tk7bmFt9sfpFOCtuX_8HA_vW8PMfgs'

export const SUPABASE_PUBLIC_URL =
  process.env.NEXT_PUBLIC_SUPABASE_URL || FALLBACK_SUPABASE_URL

export const SUPABASE_PUBLIC_ANON_KEY =
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || FALLBACK_SUPABASE_ANON_KEY

/** True when at least one public Supabase var fell back to the hardcoded default. */
export const USING_SUPABASE_FALLBACK =
  !process.env.NEXT_PUBLIC_SUPABASE_URL || !process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY
